import UIFlex from 'UIComponents/layout/UIFlex';
// @ts-expect-error untyped dependency
import FormattedDuration from 'I18n/components/FormattedDuration';
import { useShort } from '../../shortContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortCardTimeReadout = ({
  shortId,
  language
}) => {
  const {
    short,
    shortLoading
  } = useShort(shortId, language);
  if (shortLoading || !short) return null;
  const {
    duration
  } = short;
  return /*#__PURE__*/_jsx(UIFlex, {
    children: /*#__PURE__*/_jsx(FormattedDuration, {
      from: new Date().getTime() - duration * 1000
    })
  });
};
export default ShortCardTimeReadout;